import { useEffect, useRef } from 'react';
import { observer } from 'mobx-react-lite';
import type { UseFormReturn } from 'react-hook-form';
import type { EventPanelFormType, AttributeOption, CallForServiceOption } from '@mark43/cad-api';
import { useProQaMetadataStore } from '../../pro-qa/provider/pro-qa-metadata-provider';
import { useEventDraftProQaMetadataSync } from './hooks/use-event-draft-pro-qa-metadata-sync';

type Props = {
    eventId?: number;
    eventForm: UseFormReturn<EventPanelFormType>;
    eventPanelOptions?: {
        riskLevelOptions?: AttributeOption[];
        priorityOptions?: AttributeOption[];
    };
    callForServiceOptions?: CallForServiceOption[];
    currentProQaTempId?: string;
};

export const EventPanelFormProQaSync = observer(function EventPanelFormProQaSync({
    eventId,
    eventForm,
    eventPanelOptions,
    callForServiceOptions,
    currentProQaTempId,
}: Props): React.ReactElement | null {
    const proQaMetadataStore = useProQaMetadataStore();
    const currentProQaTempIdRef = useRef(currentProQaTempId);
    currentProQaTempIdRef.current = currentProQaTempId;

    const currentProQaMetadata = proQaMetadataStore.getProQaMetadata(currentProQaTempId);
    const eventDraftMetaData = currentProQaMetadata?.eventMetadata;
    const eventDraftProQaTempId = currentProQaMetadata?.tempEventId;

    // Cleared ProQA metadata on unmount to prevent stale data from being applied to a new draft.
    useEffect(() => {
        return () => {
            const tempEventId = currentProQaTempIdRef.current;
            if (!tempEventId) {
                return;
            }
            proQaMetadataStore.clearProQaMetadata(tempEventId);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEventDraftProQaMetadataSync({
        eventId,
        eventForm,
        eventPanelOptions,
        callForServiceOptions,
        eventDraftMetaData,
        currentProQaTempId,
        eventDraftProQaTempId,
    });

    return null;
});
